import { compareStrings } from "./compare-strings";

/**
 * Comparison function for sorting enum values
 */
export function compareEnums(enumDisplayValues: { [key: string]: string}, a: number | string | null | undefined, b: number | string | null | undefined): number {
    if (!a && !b) {
        return 0;
    }
    
    if (!a) {
        return -1;
    }

    if (!b) {
        return 1;
    }

    return compareStrings(enumDisplayValues[a], enumDisplayValues[b]);
}
